// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7391) return "static/chunks/7391-8fad2e9569eead06.js";
	if (chunkId === 2799) return "static/chunks/2799-a18147ff5def14ab.js";
	if (chunkId === 2246) return "static/chunks/2246-3cbe7b8c7684fea7.js";
	if (chunkId === 4722) return "static/chunks/4722-c93a3384e0d54ce0.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","7611":"79f774c5","9031":"e89fb3a8","9777":"recorder"}[chunkId] || chunkId) + "." + {"12":"a5bf2d51d224480c","151":"04d1cc6dcc7f90a1","2440":"54a07ba55faa1a7f","3557":"d52db5ace6de25ce","7611":"7061b32ca5b434ce","9031":"d46f62b1637cac16","9103":"6bb8fd46ef2b6348","9777":"25c79950f44c6781"}[chunkId] + ".js";
};